var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card-actions',[_c('p',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.title))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }